import React, { useState } from "react";
import "./OfficeStore.css";
import { Link } from "react-router-dom";

const data = {
  285: [
    {
      src: "https://estate.deltaservis.com.tr/items/5/images/1.jpg",
      alt: "210 m² Image 1",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/5/images/2.jpg",
      alt: "210 m² Image 2",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/5/images/3.jpg",
      alt: "210 m² Image 3",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/5/images/4.jpg",
      alt: "210 m² Image 3",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/5/images/5.jpg",
      alt: "210 m² Image 3",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/5/images/6.jpg",
      alt: "210 m² Image 3",
    },
  ],
  274: [
    {
      src: "https://estate.deltaservis.com.tr/items/6/images/1.jpg",
      alt: "210 m² İlan 6 Görsel 1",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/6/images/2.jpg",
      alt: "210 m² İlan 6 Görsel 2",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/6/images/3.jpg",
      alt: "210 m² İlan 6 Görsel 3",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/6/images/4.jpg",
      alt: "210 m² İlan 6 Görsel 4",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/6/images/5.jpg",
      alt: "210 m² İlan 6 Görsel 5",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/6/images/6.jpg",
      alt: "210 m² İlan 6 Görsel 6",
    },
  ],
  210: [
    {
      src: "https://estate.deltaservis.com.tr/items/7/images/1.jpg",
      alt: "210 m² İlan 7 Görsel 1",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/7/images/2.jpg",
      alt: "210 m² İlan 7 Görsel 2",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/7/images/3.jpg",
      alt: "210 m² İlan 7 Görsel 3",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/7/images/4.jpg",
      alt: "210 m² İlan 7 Görsel 4",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/7/images/5.jpg",
      alt: "210 m² İlan 7 Görsel 5",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/7/images/6.jpg",
      alt: "210 m² İlan 7 Görsel 6",
    },
  ],
  155: [
    {
      src: "https://estate.deltaservis.com.tr/items/8/images/1.jpg",
      alt: "210 m² İlan 8 Görsel 1",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/8/images/2.jpg",
      alt: "210 m² İlan 8 Görsel 2",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/8/images/3.jpg",
      alt: "210 m² İlan 8 Görsel 3",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/8/images/4.jpg",
      alt: "210 m² İlan 8 Görsel 4",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/8/images/5.jpg",
      alt: "210 m² İlan 8 Görsel 5",
    },
    {
      src: "https://estate.deltaservis.com.tr/items/8/images/6.jpg",
      alt: "210 m² İlan 8 Görsel 6",
    },
  ],
};

function OfficeStore() {
  const [selectedSize, setSelectedSize] = useState("285");
  const [mainImage, setMainImage] = useState(data[selectedSize][0]);

  const handleSizeClick = (size) => {
    setSelectedSize(size);
    setMainImage(data[size][0]);
  };

  const handleThumbnailClick = (image) => {
    setMainImage(image);
  };

  return (
    <div className="container my-5 border p-4 bg-light-2">
      <div className="row">
        <div className="col-md-6 postion-relative">
          <h1>
            <span className="bg-delta text-light px-2">Prestijli Mağaza</span>{" "}
            Portföyü
          </h1>
          <div className="advange-description my-4">
            Tuzla Mimar Sinan’da, işlek cadde üzerindeki prestijli
            dükkanlarımız; yüksek kira getirisi, kurumsal çevre ve her iş koluna
            uygun seçenekler sunuyor!
          </div>
          <div className="row advanges">
            <div className="col-md-6">
              <i className="fa fa-check"></i>
              Düz girişli yapısıyla erişim ve kullanım kolaylığı sunar.
            </div>
            <div className="col-md-6">
              <i className="fa fa-check"></i>
              Asma katı sayesinde hem depolama hem iş alanı sağlar.
            </div>
            <div className="col-md-6">
              <i className="fa fa-check"></i>
              Tabela değeri yüksek, markanızı öne çıkarır.
            </div>
            <div className="col-md-6">
              <i className="fa fa-check"></i>
              Otobüs ve minibüs güzergahları üzerinde konumlanmıştır.
            </div>
            <div className="col-md-6">
              <i className="fa fa-check"></i>
              2.72 metre giriş tavan yüksekliği ile ferah bir ortam sunar.
            </div>
            <div className="col-md-6">
              <i className="fa fa-check"></i>
              Ön alan kullanım ile ek sergileme alanları yaratır.
            </div>
          </div>
          <div className="d-flex pt-4 justify-content-between">
            <h5 className="custom-h5">Bağımsız Birim Alternatifleri:</h5>
            <Link className="more-info" to="/projects/store">
              Daha Fazla
            </Link>
          </div>
          <div className="size-buttons">
            {Object.keys(data)
              .reverse()
              .map((size) => (
                <button
                  key={size}
                  onClick={() => handleSizeClick(size)}
                  className={`size-button ${
                    selectedSize === size ? "active" : ""
                  }`}
                >
                  <div>
                    {size} m<sub>2</sub>
                  </div>
                </button>
              ))}
          </div>
        </div>
        <div className="col-md-6">
          <div className="gallery-slider">
            <div className="slider">
              <div className="main-image">
                <img src={mainImage.src} alt={mainImage.alt} />
              </div>
              <div className="thumbnails">
                {data[selectedSize].map((image) => (
                  <img
                    key={image.src}
                    src={image.src}
                    alt={image.alt}
                    onClick={() => handleThumbnailClick(image)}
                    className={`thumbnail ${
                      mainImage.src === image.src ? "active" : ""
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OfficeStore;
